// Imports
import { Route } from 'react-router-dom';
import Blog from '.';
import Post from './post';
import Tag from './tag';


// Function component
const sectionRoutes = (
	<Route path='blog'>
		<Route index element={<Blog />} handle={{ hideCTA: true }} />
		<Route path='loading' element={<Post />} handle={{ alternateCTA: true }} />
		<Route path=':postIdentifier' element={<Post />} handle={{ alternateCTA: true }} />
		<Route path='p/:postUUID' element={<Post />} handle={{ alternateCTA: true }} />
		<Route path='tag/loading' element={<Tag />} handle={{ hideCTA: true }} />
		<Route path='tag/:tagIdentifier' element={<Tag />} handle={{ hideCTA: true }} />
	</Route>
);

export default sectionRoutes;
